module.exports = __webpack_public_path__ + "img/EMERALD Icon.1ead80db.png";